<template>
  <div>
    <div class="index-page">
      <div class="dep-box">
        <div class="total-box">
          <c-block-box title="总体营收" class="margin-bottom-1rem">
            <div class="revenue-total">
              <div class="the-month--revenue box">
                <div class="title">实时总营收（万元）</div>
                <div class="Year-To-Date">年累计 {{ numberSplitWithComma((dashboard.totalReceive.yearTotalIncome || 0)) }}</div>
                <div class="revenue-statistics">
                  <div class="total-revenue">{{ numberSplitWithComma((dashboard.totalReceive.monthIncome || 0)) }}</div>
                  <div class="tendency">
                    <div class="tendency-text">
                      <span>环比</span>
                      <img :src="upsAndDowns(dashboard.totalReceive.monthRatio || 0)" />
                      <em>{{ percentage(dashboard.totalReceive.monthRatio) }}%</em>
                    </div>
                    <div class="tendency-text">
                      <span>同比</span>
                      <img :src="upsAndDowns(dashboard.totalReceive.weekRatio || 0)" />
                      <em>{{ percentage(dashboard.totalReceive.weekRatio) }}%</em>
                    </div>
                  </div>
                  <div class="revenue-target">目标 {{ numberSplitWithComma((dashboard.totalReceive.monthTarget || 0 ) * 1) + '万' }}</div>
                </div>
                <div class="target-rate">
                  <c-target-rate
                    label="完成率"
                    :num="percentage(dashboard.totalReceive.monthFinishRatio)"
                  >
                  </c-target-rate>
                  <c-target-rate
                    label="匹配度"
                    :num="percentage(dashboard.totalReceive.targetFinishRatio)"
                  >
                  </c-target-rate>
                </div>
              </div>
              <div class="revenue-trend box">
                <div class="title">营收趋势</div>
                <ChartBarLine
                  id="revenueTrend"
                  width="100%"
                  height="9.25rem"
                  :option="revenueTrend"
                ></ChartBarLine>
              </div>
              <div class="dep-revenue-trend box">
                <div class="title">营收柱状图</div>
                <ChartBarLine
                  id="dep-revenue-trend"
                  width="100%"
                  height="9.25rem"
                  :option="depRevenueTrend"
                ></ChartBarLine>
              </div>
            </div>
          </c-block-box>
        </div>
        <div class="dep-box--line1">
          <div
            class="line-left coocaa_btn"
            id="dep-1"
            upTarget="#index"
            depLink="/parlor"
          >
            <c-block-box title="大内容事业部">
              <div class="line-box">
                <div class="order-complete">
                  <div class="complete-flex complete-flex0">
                    <div class="name">营收（万元）</div>
                    <div class="complete-data">
                      <div class="value">{{ numberSplitWithComma((dashboard.livingRoom.weekOpen.monthNetIncome || 0).toFixed(2)) }}</div>
                      <div class="tendency">
                        <div class="tendency-text">
                          <span>环比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.monthNetRatio || 0)" />
                          <em>{{ percentage(dashboard.livingRoom.weekOpen.monthNetRatio).toFixed(1) }}%</em>
                        </div>
                        <div class="tendency-text">
                          <span>同比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.monthYRatio || 0.01)" />
                          <em>{{ percentage(dashboard.livingRoom.weekOpen.monthYRatio).toFixed(1) }}%</em>
                        </div>
                      </div>
                    </div>
                    <div class="target">目标 {{ numberSplitWithComma((dashboard.livingRoom.weekOpen.monthTarget || 0) * 1) + '万' }}</div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.livingRoom.weekOpen.monthFinishRatio)"
                        height="0.7rem"
                        width="6rem"
                      >
                      </c-target-rate>
                      <c-target-rate
                        label="匹配度"
                        :num="percentage(dashboard.livingRoom.weekOpen.targetFinishRatio)"
                        height="0.7rem"
                        width="6rem"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                  <div class="complete-flex complete-flex1">
                    <div class="name">活跃率</div>
                    <div class="complete-data">
                      <div class="value">{{ percentage(dashboard.livingRoom.weekOpen.activeRate) }}%</div>
                      <div class="tendency">
                        <!-- <div class="tendency-text">
                          <span>月环比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.activeRateCompare || 0)" />
                          <em> {{ percentage(dashboard.livingRoom.weekOpen.activeRateCompare).toFixed(2) }}%</em>
                        </div> -->
                        <div class="tendency-text">
                          <span>同比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.activeRateTargetRate || 0)" />
                          <em>{{ percentage(dashboard.livingRoom.weekOpen.activeRateTargetRate) }}%</em>
                        </div>
                      </div>
                    </div>
                    <div class="target">目标 {{ `${percentage(dashboard.livingRoom.weekOpen.activeRateTarget || 0)}%` }}</div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.livingRoom.weekOpen.activeRateTargetRate)"
                        height="0.7rem"
                        width="6rem"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                  <div class="complete-flex complete-flex2">
                    <div class="name">转化率</div>
                    <!-- <div class="value">{{ ((dashboard.livingRoom.weekOpen.payConversionRate || 0) * 100).toFixed(2) }}</div> -->
                    <div class="complete-data">
                      <div class="value">{{ percentage(dashboard.livingRoom.weekOpen.conversionRate) }}%</div>
                      <div class="tendency">
                        <!-- <div class="tendency-text">
                          <span>月环比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.weekConversionRateCompare || 0)" />
                          <em>{{ 500 }}%</em>
                        </div> -->
                        <div class="tendency-text">
                          <span>同比</span>
                          <img :src="upsAndDowns(dashboard.livingRoom.weekOpen.conversionRateCompare || 0)" />
                          <em>{{ percentage(dashboard.livingRoom.weekOpen.conversionRateCompare) }}%</em>
                        </div>
                      </div>
                    </div>
                    <div class="target">目标 {{ `${percentage(dashboard.livingRoom.weekOpen.conversionRateTarget || 0)}%` }}</div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.livingRoom.weekOpen.conversionRateTargetRate)"
                        height="0.7rem"
                        width="6rem"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                </div>
                <ChartBarLine
                  id="business-line"
                  width="100%"
                  height="9.75rem"
                  :option="businessLine"
                ></ChartBarLine>
              </div>
            </c-block-box>
          </div>
          <div
            class="line-right coocaa_btn"
            id="dep-2"
            upTarget="#index"
            rightTarget="#index"
            depLink="/digital-marketing"
          >
            <c-block-box title="数字营销事业部">
              <div class="line-box">
                <div class="digital-marketing-1">
                  <div class="marketing-left">
                    <div class="title">营收（万元）</div>
                    <div class="revenue-box">
                      <div class="number">{{ numberSplitWithComma((dashboard.digitalMarketing.monthIncome || 0).toFixed(2)) }}</div>
                      <div class="tendency-text">
                        <span>环比</span>
                        <img :src="upsAndDowns(dashboard.digitalMarketing.monthRatio || 0)" />
                        <em>{{ percentage(dashboard.digitalMarketing.monthRatio) }}%</em>
                      </div>
                    </div>
                    <div class="finishing-rate">
                      <c-target-rate
                        label="目标"
                        :target="(dashboard.digitalMarketing.monthTarget || 0) + '万'"
                        :is-progress="false"
                      >
                      </c-target-rate>
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.digitalMarketing.monthFinishRatio) * 1"
                      >
                      </c-target-rate>
                      <c-target-rate
                        label="匹配度"
                        :num="percentage(dashboard.digitalMarketing.targetFinishRatio) * 1"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                  <div class="marketing-right">
                    <div class="line1">
                      <span>完单率</span>
                      <em>{{ percentage(dashboard.digitalMarketing.projectRate || 0) }}%</em>
                    </div>
                    <div class="line2">
                      <span class="lable">执行项目数：</span>
                      <em>{{ dashboard.digitalMarketing.pfinishNum || 0 }}</em>
                      <span class="lable">缺量项目数：</span>
                      <em>{{ dashboard.digitalMarketing.pundoneNum || 0 }}</em>
                    </div>
                  </div>
                </div>
                <div class="digital-marketing-2">
                  <div class="box box0">
                    <div class="table-item">
                      <div class="table-head">
                        <div class="head-item head-item1 up-and-down"><span>区域<br /><em>周总库存</em></span></div>
                        <div class="head-item up-and-down"><span>库存量<br /><em>（CPM）</em></span></div>
                        <div class="head-item up-and-down"><span>售出量<br /><em>（CPM）</em></span></div>
                        <div class="head-item up-and-down"><span>售出率</span></div>
                      </div>
                      <div class="table-body">
                        <div class="table-line" v-for="(item, index) in dashboard.digitalMarketing.stock" :key="index">
                          <div class="body-lable up-and-down">
                            <span>{{ item.name }}</span>
                          </div>
                          <div class="body-lable up-and-down">
                            <span>{{ item.stock }}</span>
                          </div>
                          <div class="body-lable up-and-down">
                            <span>{{ item.sale }}</span>
                          </div>
                          <div class="body-lable up-and-down">
                            <span>{{ percentage(item.saleRatio * 1) }}%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box box1">
                    <div class="title">各流量CPM售卖对比</div>
                    <ChartPie
                      id="business-ratio"
                      height="8rem"
                      width="100%"
                      :option="businessRatio"
                    ></ChartPie>
                  </div>
                  <div class="box box1">
                    <div class="title">销售效能 <span>昨日跟进记录：{{ dashboard.digitalMarketing.dayRecord ? dashboard.digitalMarketing.dayRecord.recordNum || 0 : 0 }}</span></div>
                    <div class="trapezoid">
                      <div class="trapezoid-box">
                        <div class="box-flex">
                          <div class="value">{{ dashboard.digitalMarketing.monthRecord.totalRecord || 0 }}</div>
                          <div class="name">跟进记录</div>
                        </div>
                        <div class="box-flex">
                          <div class="value">{{ dashboard.digitalMarketing.monthRecord.totalBop || 0 }}</div>
                          <div class="name">商机录入</div>
                        </div>
                        <div class="box-flex">
                          <div class="value">{{ dashboard.digitalMarketing.monthRecord.expect || 0 }}</div>
                          <div class="name"><c-manual-icon style="padding:0 .1rem; margin-left:0; margin-right:.1rem"></c-manual-icon>预计开单</div>
                        </div>
                      </div>
                      <div class="box one"></div>
                      <div class="box two"></div>
                      <div class="box three"></div>
                    </div>
                  </div>
                </div>
              </div>
            </c-block-box>
          </div>
        </div>
        <div class="dep-box--line2">
          <div
            class="line-left coocaa_btn"
            id="dep-3"
            depLink="/media-financial"
          >
            <c-block-box title="融媒体事业部">
              <div class="line-box">
                <div class="media-financial--left">
                  <div class="title">营收（万元）</div>
                  <div class="value">{{ (dashboard.media.monthIncome || 0).toFixed(2) }}</div>
                  <div class="tendency">
                    <div class="tendency-text">
                      <span>环比</span>
                      <img :src="upsAndDowns(dashboard.media.monthRatio)" />
                      <em>{{ percentage(dashboard.media.monthRatio) }}%</em>
                    </div>
                    <div class="tendency-text">
                      <span>同比</span>
                      <img :src="upsAndDowns(dashboard.media.monthYRatio)" />
                      <em>{{ percentage(dashboard.media.monthYRatio) }}%</em>
                    </div>
                  </div>
                  <div class="target">目标 {{ dashboard.media.monthTarget * 1 + '万' }}</div>
                  <div class="target-rate">
                    <c-target-rate
                      label="完成率"
                      :num="percentage(dashboard.media.monthFinishRatio)"
                    >
                    </c-target-rate>
                    <c-target-rate
                      label="匹配度"
                      :num="percentage(dashboard.media.targetFinishRatio)"
                    >
                    </c-target-rate>
                  </div>
                  <!-- <div class="Year-To-Date">年累计 {{ (dashboard.media.yearTotalIncome || 0).toFixed(2) }}</div> -->
                </div>
                <div class="media-financial--right">
                  <div class="title">累计终端数及占比</div>
                  <ChartPie
                    id="media-financial-pie"
                    height="6rem"
                    width="6rem"
                    style="margin-top: 1rem"
                    :option="mediaFinancialPie"
                  ></ChartPie>
                  <div class="media-financial-legend">
                    <div class="line" v-for="(item, index) in mediaFinancialPie.data" :key="index">
                      <span>{{ item.name }}</span>
                      <em>{{ item.num }}万台</em>
                      <em>{{ item.value }}%</em>
                    </div>
                  </div>
                </div>
              </div>
            </c-block-box>
          </div>
          <div
            class="line-right coocaa_btn"
            id="dep-4"
            rightTarget="#index"
            depLink="/share-screen"
          >
            <c-block-box title="共享屏事业部" :icon="true">
              <div class="line-box flex-gx">
                <div class="overview" id="no-flex">
                  <div class="overview-l">
                    <div class="title">新增用户数</div>
                    <div class="revenue-box">
                      <div class="number">{{ dashboard.share.userAdd }}</div>
                    </div>
                  </div>
                  <div class="overview-r revenue-box-right">
                    <div class="tendency">
                      <div class="tendency-text">
                        <span>环比</span>
                        <img :src="upsAndDowns(dashboard.share.userMonthRate || '0')" />
                        <em>{{ percentage(dashboard.share.userMonthRate || '0') }}%</em>
                      </div>
                      <!-- <div class="tendency-text">
                        <span>月同比</span>
                        <img :src="upsAndDowns(dashboard.share.monthRatio || 0)" />
                        <em>{{ 500 }}%</em>
                      </div> -->
                    </div>
                    <div class="target-rate">
                      <div class="target">
                        目标 {{ (dashboard.share.userAddTarget * 1).toString() }}
                      </div>
                    </div>
                    <div class="target-rate">
                      <c-target-rate
                        label="完成率"
                        :num="percentage(dashboard.share.userAddTargetFinishRate || '0')"
                      >
                      </c-target-rate>
                    </div>
                  </div>
                </div>
                <ChartBarLineTwo
                  id="share-line"
                  width="100%"
                  :style="{
                  }"
                  name=""
                  height="11.2rem"
                  :option="shareLine"
                ></ChartBarLineTwo>
              </div>
            </c-block-box>
          </div>
        </div>
      </div>
      <div class="account-receivable">
        <c-block-box title="非实时结算营收">
          <div class="account-receivable--box">
            <div class="title">营收（万元）</div>
            <div class="revenue-statistics">
              <div class="total-revenue">{{ numberSplitWithComma((dashboard.monthIncome.monthIncome.monthIncome || 0).toFixed(2)) }}</div>
            </div>
            <div class="target-rate">
              <c-target-rate
                label="目标"
                :target="(dashboard.monthIncome.monthIncome.monthTarget || 0) + '万'"
                :is-progress="false"
              >
              </c-target-rate>
              <c-target-rate
                label="完成率"
                :num="percentage(dashboard.monthIncome.monthIncome.monthRatio || 0)"
                width="7rem"
              >
              </c-target-rate>
              <c-target-rate
                label="匹配度"
                :num="percentage(dashboard.monthIncome.monthIncome.monthTargetRatio || 0)"
                width="7rem"
              >
              </c-target-rate>
            </div>
            <div class="table-item">
              <div class="table-head">
                <div class="head-item">事业部</div>
                <div class="head-item">创维终端</div>
                <div class="head-item">外部终端</div>
              </div>
              <div class="table-body">
                <div class="table-line" v-for="(item, index) in dashboard.monthIncome.detail" :key="index">
                  <div class="body-lable up-and-down">
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="body-lable up-and-down">
                    <span>{{ (item.skyWorth * 1).toFixed(2) }}</span>
                  </div>
                  <div class="body-lable up-and-down">
                    <span>{{ (item.other * 1).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="title">非实时营收占比</div>
            <ChartPie
              id="account-receivable-ratio"
              height="11rem"
              width="100%"
              :option="accountReceivableRatio"
            ></ChartPie>
          </div>
        </c-block-box>
      </div>
    </div>
  </div>
</template>

<script>
import ChartPie from '@/components/echarts/pie'
import ChartBarLine from '@/components/echarts/line1'
import ChartBarLineTwo from '@/components/echarts/line2'
import * as echarts from 'echarts'
import common from '@/mixins/common.js'
export default {
  mixins: [common],
  components: {
    ChartPie,
    ChartBarLine,
    ChartBarLineTwo
  },
  props: {},
  data () {
    return {
      revenueTrend: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          containLabel: true
        },
        legend: {},
        xData: [],
        series: [],
        boundaryGap: false,
        color: ['#1895FF', '#1EE4DC', '#FFA800']
      },
      depRevenueTrend: {
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          containLabel: true
        },
        legend: {},
        boundaryGap: true,
        alignWithLabel: true,
        color: ['#1895FF', '#1EE4DC', '#FFD71A'],
        xData: [],
        series: []
      },
      businessLine: {
        title: {
          text: '各业务营收曲线',
          x: 'left',
          left: 20,
          top: 15,
          textStyle: {
            fontSize: 14,
            color: 'rgba(255,255,255,.6)',
            lineHeight: 30
          }
        },
        legend: {
          top: 20
        },
        grid: {
          left: 10,
          right: 20,
          bottom: 10,
          top: 60,
          containLabel: true
        },
        boundaryGap: false,
        color: ['#FF5A18', '#FFD71A', '#1895FF', '#1EE4DC'],
        xData: [],
        series: []
      },
      shareLine: {
        config: {
          legend: {
            orient: 'vertical',
            right: this.$isAndroid ? 0 : 10,
            top: this.$isAndroid ? 10 : 20
          },
          grid: {
            left: this.$isAndroid ? 0 : 10,
            right: 20,
            bottom: this.$isAndroid ? 10 : 0,
            top: this.$isAndroid ? 85 : 80,
            containLabel: true
          },
          boundaryGap: false,
          splitNumber: 2,
          yAxis: [
            {
              name: '人',
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: 'rgba(255,255,255,0.1)'
                }
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(255,255,255,0.1)'
                }
              },
              axisLabel: {
                textStyle: {
                  color: 'rgba(255,255,255,.6)',
                  fontSize: !this.$isAndroid ? 12 : 10
                }
              },
              nameTextStyle: {
                color: '#999',
                fontSize: !this.$isAndroid ? 12 : 10
              },
              splitArea: {
                show: false
              },
              splitNumber: 2
            }
            // ,
            // {
            //   name: '%',
            //   type: 'value',
            //   splitLine: {
            //     lineStyle: {
            //       color: 'rgba(255,255,255,0.1)'
            //     }
            //   },
            //   axisLine: {
            //     show: false,
            //     lineStyle: {
            //       color: 'rgba(255,255,255,0.1)'
            //     }
            //   },
            //   axisLabel: {
            //     textStyle: {
            //       color: 'rgba(255,255,255,.6)',
            //       fontSize: !this.$isAndroid ? 12 : 10
            //     }
            //   },
            //   nameTextStyle: {
            //     color: '#999',
            //     fontSize: !this.$isAndroid ? 12 : 10
            //   },
            //   splitArea: {
            //     show: false
            //   },
            //   splitNumber: 2
            // }
          ]
        },
        // color: ['#FF5A18', '#FFD71A', '#1895FF', '#1EE4DC'],
        series: []
      },
      // devicePie: {
      //   config: {
      //     type: 2,
      //     picRadius: '80%',
      //     picCenter: ['30%', '50%'],
      //     tooltip: {
      //       show: true
      //     },
      //     legend: {
      //       right: 30,
      //       bottom: 30
      //     }
      //   },
      //   data: []
      // },
      mediaFinancialPie: {
        config: {
          type: 2,
          picRadius: ['100%', '70%'],
          tooltip: {
            show: false
          },
          seriesLabel: {
            show: false
          },
          legend: {
            show: false,
            right: 30,
            bottom: 30
          }
        },
        data: []
      },
      businessRatio: {
        config: {
          type: 2,
          picRadius: '65%',
          picCenter: ['50%', '35%'],
          tooltip: {
            show: true
          },
          legend: {
            bottom: 0,
            height: this.$isAndroid ? 30 : 40,
            textStyle: {
              fontSize: this.$isAndroid ? 10 : 12,
              color: 'rgba(255, 255, 255, 0.8)'
            }
          }
        },
        data: []
      },
      accountReceivableRatio: {
        config: {
          type: 2,
          picRadius: '80%',
          picCenter: ['30%', '50%'],
          tooltip: {
            show: true
          },
          legend: {
            right: 20,
            y: 'center'
          }
        },
        data: [
          { name: '创维终端', value: '78' },
          { name: '外部终端', value: '22' }
        ]
      },
      dashboard: {
        totalReceive: {},
        livingRoom: {
          weekOpen: {}
        },
        digitalMarketing: {
          monthRecord: {}
        },
        share: {},
        media: {},
        monthIncome: {
          monthIncome: {}
        }
      }
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    percentage (num) {
      return parseFloat((num * 100).toFixed(2))
    },
    lineFormatData (data, series, dashedType, type) {
      const keys = Object.keys(data)
      return {
        xData: data[keys[0]].date.map(item => {
          return this.$cUtils.format.formatDate(item, 'MM-dd')
        }),
        series: keys.map(item => {
          let areaStyle = {}
          if (type && item !== dashedType) {
            areaStyle = {}
            this.$set(areaStyle, 'areaStyle', {})
          }
          let barWidth = 5
          if (series.type === 'bar') {
            if (data[item].data.length > 0 && data[item].data.length <= 10) {
              barWidth = 20
            } else if (data[item].data.length > 10 && data[item].data.length <= 20) {
              barWidth = 15
            }
          }
          return {
            name: item,
            data: data[item].data,
            stack: item === dashedType ? '' : '总量',
            lineStyle: {
              width: this.isAndroid ? 0.5 : 2,
              type: item === dashedType ? 'dashed' : 'solid'
            },
            barWidth,
            ...series,
            ...areaStyle
          }
        })
      }
    },
    lineFormatDataTwo (data, series) {
      const keys = Object.keys(data)
      return {
        config: {
          ...this.shareLine.config,
          xData: data[keys[0]].date.map(item => {
            return this.$cUtils.format.formatDate(item, 'MM-dd')
          })
        },
        data: keys.map((item, index) => {
          return {
            name: item,
            data: data[item].data,
            lineStyle: {
              type: item === '目标' ? 'dashed' : 'solid',
              width: this.isAndroid ? 0.5 : 2
            },
            // yAxisIndex: index,
            ...series
          }
        })
      }
    }
  },
  activated () {
    const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
    this.$service.fetch({
      url: 'api/global/dashboard',
      params: {
        month: choiceDate.time // '2021-01'
      }
    }).then(res => {
      this.$set(this, 'dashboard', res)
      if (!this.dashboard.digitalMarketing.monthRecord) { this.dashboard.digitalMarketing.monthRecord = {} }
      const lineConfig = {
        symbol: 'none',
        type: 'line',
        stack: '',
        lineStyle: {
          width: this.isAndroid ? 0.5 : 2
        }
        // smooth: true
      }
      const totalReceive = res.totalReceive
      const livingRoom = res.livingRoom
      const share = res.share
      const skyWorthIncomeDetail = totalReceive.skyWorthIncomeDetail
      const businessIncomeDetail = totalReceive.businessIncomeDetail
      this.revenueTrend = Object.assign(this.revenueTrend, this.lineFormatData(skyWorthIncomeDetail, {
        symbol: 'none',
        type: 'line'
        // smooth: true
      }, '目标', 1), {})
      this.depRevenueTrend = Object.assign(this.depRevenueTrend, this.lineFormatData(businessIncomeDetail, {
        symbol: 'none',
        type: 'bar',
        barCateGoryGap: 1,
        // smooth: true,
        stack: '总量'
      }))
      this.$set(this.revenueTrend.grid, 'top', !this.isAndroid ? 60 : 40)
      this.$set(this.revenueTrend.legend, 'top', !this.isAndroid ? 20 : 10)
      this.$set(this.depRevenueTrend.grid, 'top', !this.isAndroid ? 60 : 40)
      this.$set(this.depRevenueTrend.legend, 'top', !this.isAndroid ? 20 : 10)
      // this.depRevenueTrend = Object.assign(this.depRevenueTrend, this.lineFormatData(businessIncomeDetail, lineConfig))
      this.businessLine = Object.assign(this.businessLine, this.lineFormatData(livingRoom.monthDetail, lineConfig))
      this.shareLine = Object.assign(this.shareLine, this.lineFormatDataTwo(share.user, {
        symbol: 'none',
        type: 'line'
      }))
      // const mediaPie = [{
      //   name: '创维终端',
      //   value: parseFloat((res.media.skyWorthRatio * 100).toFixed(2)),
      //   value1: res.media.skyWorth
      // }, {
      //   name: '外部终端',
      //   value: parseFloat((res.media.otherRatio * 100).toFixed(2)),
      //   value1: res.media.other
      // }]
      this.mediaFinancialPie.data = res.media.pieChart.map(item => {
        return {
          name: item.name,
          value: parseFloat((item.value * 100).toFixed(2)),
          num: parseFloat(((item.name.indexOf('创维') >= 0 ? res.media.skyWorth : res.media.other) / 10000).toFixed(2))
        }
      })
      // this.devicePie.data = totalReceive.pieChart.map(item => {
      //   return {
      //     name: item.name,
      //     value: parseFloat((item.value * 100).toFixed(2))
      //   }
      // })

      const pieDigital = res.digitalMarketing.day || {}
      if (Object.keys(pieDigital).length > 0) {
        this.businessRatio.data = [{
          name: '创意流量',
          value: (pieDigital.creativeFlowRatio * 100).toFixed(2)
        }, {
          name: '常规流量',
          value: (pieDigital.regularFlowRatio * 100).toFixed(2)
        }, {
          name: '数据精准',
          value: (pieDigital.accurateFlowRatio * 100).toFixed(2)
        }, {
          name: '常规精准',
          value: (pieDigital.ordinaryAccurateFlowRatio * 100).toFixed(2)
        }]
      } else {
        this.businessRatio.data = []
      }
      // res.digitalMarketing.pieChart.map(item => {
      //   return {
      //     name: item.name,
      //     value: parseFloat((item.value * 100).toFixed(2))
      //   }
      // })
      // if (res.monthIncome.detail.length < 1) {
      //   this.dashboard.monthIncome.detail = [
      //     { name: '客厅事业部', skyWorth: '', other: '' },
      //     { name: '数字营销事业部', skyWorth: '', other: '' },
      //     { name: '融媒体事业部', skyWorth: '', other: '' },
      //     { name: '共享屏事业部', skyWorth: '', other: '' },
      //     { name: '其他', skyWorth: '', other: '' }
      //   ]
      // }
      this.accountReceivableRatio.data[0].value = (res.monthIncome.skyWorthRatio * 100).toFixed(2)
      this.accountReceivableRatio.data[1].value = (res.monthIncome.otherRatio * 100).toFixed(2)
      this.$nextTick(() => {
        this.$parent.bindKey()
      })
    })
  }
}
</script>

<style lang="stylus" scoped>
  @import './stylus/Index-3.2.styl'
  .flex-gx
    display flex
  #no-flex
    display initial
    .revenue-box-right
      padding-left 0
</style>
